function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.33 12.5l9.08-9.09a2 2 0 000-2.82 2 2 0 00-2.82 0L12.5 9.67 3.41.59a2 2 0 00-2.82 0 2 2 0 000 2.82l9.08 9.09-9.08 9.09a2 2 0 000 2.82 2 2 0 002.82 0l9.09-9.08 9.09 9.08a2 2 0 002.82-2.82z"
});

var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Ebene 1",
    viewBox: "0 0 25 25"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyBkYXRhLW5hbWU9IkViZW5lIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDI1IDI1Ij48dGl0bGU+WmVpY2hlbmZsw6RjaGUgMzU8L3RpdGxlPjxwYXRoIGQ9Ik0xNS4zMywxMi41bDkuMDgtOS4wOWEyLDIsMCwwLDAsMC0yLjgyLDIsMiwwLDAsMC0yLjgyLDBMMTIuNSw5LjY3LDMuNDEuNTlBMiwyLDAsMCwwLC41OS41OWEyLDIsMCwwLDAsMCwyLjgyTDkuNjcsMTIuNS41OSwyMS41OWEyLDIsMCwwLDAsMCwyLjgyLDIsMiwwLDAsMCwyLjgyLDBsOS4wOS05LjA4LDkuMDksOS4wOGEyLDIsMCwwLDAsMi44Mi0yLjgyWiIvPjwvc3ZnPg==";
export { SvgClose as ReactComponent };